import tuneInRequest from '../tuneInRequest';
export default function partnersService(config, apiContext) {
    const apiEndpoint = `${config.domains.api}/partners`;
    const linkSonosEndpoint = `${config.domains.sonos}/account/link`;
    function get(id) {
        return tuneInRequest({
            method: 'get',
            url: `${apiEndpoint}/${id}`,
        }, apiContext);
    }
    function linkSonos(formData) {
        return tuneInRequest({
            method: 'post',
            url: linkSonosEndpoint,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }, apiContext);
    }
    return {
        get,
        linkSonos,
    };
}
